import { useAuth, createAuthAxios } from '../context/AuthContext';
import { useMemo } from 'react';

export const useApi = () => {
  const { token } = useAuth();

  const api = useMemo(() => createAuthAxios(token), [token]);

  return api;
};

/** Extract a user-friendly error message from an API error. */
export const getErrorMessage = (error, fallback = 'Une erreur est survenue') => {
  return error?.userMessage || fallback;
};

export default useApi;
